import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	todayButton: {
		id: 'business-calendar.calendar-view.toolbar.today-button',
		defaultMessage: 'Today',
		description: 'Text for user to navigate to today date',
	},
	nextMonthButton: {
		id: 'business-calendar.calendar-view.toolbar.next-month-button',
		defaultMessage: 'Next month',
		description: 'Text for user to navigate to next month',
	},
	prevMonthButton: {
		id: 'business-calendar.calendar-view.toolbar.prev-month-button',
		defaultMessage: 'Previous month',
		description: 'Text for user to navigate to previous month',
	},
	shareTitle: {
		id: 'business-calendar.calendar-view.toolbar.share-title',
		defaultMessage: 'Calendar',
		description:
			'Name of the entity type that is going to be shared to others, this will be used as email title for the share recipients',
	},
	simpleSearch: {
		id: 'business-calendar.calendar-view.toolbar.simple-search',
		defaultMessage: 'Search calendar',
		description:
			'Placeholder of the text field above the calendar that allows the user to search by text',
	},
	unscheduled: {
		id: 'business-calendar.calendar-view.toolbar.unscheduled',
		defaultMessage: 'Unscheduled',
		description:
			'Placeholder of the text field above the calendar that allows the user to see the unscheduled items',
	},
});
